import { Assessment } from '$synapse/models';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { genericBaseUrl } from '$synapse/services';
import { AssessmentDTO, mapToAssessment } from 'src/app/dtos';

@Injectable({
  providedIn: 'root',
})
export class InterviewService {
  private readonly _http = inject(HttpClient);

  baseUrl(...path: any[]): string {
    return genericBaseUrl(
      `${environment.settings.api.url}/manager/interviews`,
      ...path
    );
  }

  generateAssessmentInterview(): Observable<Assessment> {
    return this._http
      .post<AssessmentDTO>(this.baseUrl(), {})
      .pipe(map((assessmentDto) => mapToAssessment(assessmentDto)));
  }

  getAssessmentById(id: string): Observable<Assessment> {
    return this._http
      .get(this.baseUrl() + `/${id}`)
      .pipe(
        map((assessmentDto: AssessmentDTO) => mapToAssessment(assessmentDto))
      );
  }
}
